import React, { Component } from 'react';
import { Container, Navbar, Row, Nav } from 'react-bootstrap';
import Imprint  from './Imprint.js';
import Skills  from './Skills.js';
import Projects  from './Projects.js';
import Cv  from './Cv.js';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Link
} from "react-router-dom";

class AppPage extends Component { 

    render() {
        return (
            <Container>
                <Navbar expand="lg">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <NavLink to="/" className="nav-link">Home</NavLink>
                            <NavLink to="/cv" className="nav-link">Curriculum Vitae</NavLink>
                            <NavLink to="/skills" className="nav-link">Skills</NavLink>
                            <NavLink to="/projects" className="nav-link">Projekte</NavLink>
                            <NavLink to="/imprint" className="nav-link">Impressum</NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <Container className="bg">
                    <Container className="profil"> 
                        <h1>Mike&nbsp;Keller</h1>
                        <h5>Software&nbsp;Entwickler</h5>
                        <p>&nbsp;<br/>&nbsp;</p>
                    </Container>
                </Container>
                <Container>
                    <Switch>
                        <Route path="/cv">
                            <Cv />
                        </Route>
                        <Route path="/skills">
                            <Skills />
                        </Route>
                        <Route path="/projects">
                            <Projects />
                        </Route>
                        <Route path="/imprint">
                            <Imprint />
                        </Route>
                        <Route path="/">
                            <Row>
                                <div class="col-xs-6 col-md-4">
                                <h3>Curriculum Vitae</h3>
                                <p>Ab einem gewissen Lebensalter und der damit einhergehenden Berufserfahrung, werden Schulabschlüsse und Ausbildungen nebensächlich. Nichtsdestotrotz haben diese Eckdaten eine entsprechende Aussagekraft.</p>
                                <p>Hier finden Sie eine tabellarische Zusammenstellung meiner Eckdaten.</p>
                                <p><Link to="/cv">weiter ...</Link></p>
                                </div>
                                <div class="col-xs-6 col-md-4">
                                <h3>Skills</h3>
                                <p>In den über 20 Jahren als Softwareentwickler habe ich mich hauptsächlich im Microsoft Umfeld bewegt. Beginnend mit Datenbanken in Access, Microsoft SQL Server, Oracle über Windows Applikationen in WPF bis hin zu Single Page Applikationen.</p>
                                <p>Meine Kerntätigkeit in den letzten Jahren bestand neben der Entwicklung von WPF- und Web-Applikationen auch in der Planung und Umsetzung von automatisierten GUI-Tests.</p>
                                <p>In den vergangenen 2 Jahren hatte ich die Möglichkeit, neben dem Microsoft Umfeld, auch plattformübergreifend mit Java zu entwickeln.</p>
                                <p><Link to="/skills">weiter ...</Link></p>
                                </div>
                                <div class="col-xs-6 col-md-4">
                                <h3>Projekte</h3>
                                <p>Meine Aufgaben in den vergangenen Jahren waren breitgefächert und umfassten je nach Projekt Architektur, Persistierung, Businesslogik, Frontend, Testing und/oder aufsetzten der CI/CD Pipeline.</p>
                                <p>In diese Bereich finden Sie eine Übersicht einiger meiner letzten Projekte.</p>
                                <p><Link to="/projects">weiter ...</Link></p>
                                <br />&nbsp;
                                <br />&nbsp;
                                </div>
                            </Row>
                        </Route>
                    </Switch>
                </Container>
            </Container>
        );
    }
}

export default AppPage;